import { IconName } from "@components/ui/Icon/IconName"

export type BaseSection = {
  name: string
}

export type SectionDetails =
  | {
      label: string
      value: string
      analysis?: string | null
    }
  | ListReport

export type SubSection = BaseSection & {
  value: string
  type: "section"
}

export type TextReport = BaseSection & {
  type: "section"
  details: SectionDetails[] | string
}

export type TableDetails = {
  headers: string[]
  rows: string[][]
  analysis?: string | null
}

export type TableReport = BaseSection & {
  name: string
  type: "table"
  details: TableDetails[]
}

export type ListDetails = {
  label: string
  subsections?: SubSection[]
  analysis?: string | null
}

export type ListReport = BaseSection & {
  name: string
  type: "list"
  details: ListDetails[]
}

export type Section = TextReport | TableReport | ListReport

export type ReportStatus = "in-progress" | "failed" | "completed"

export type ReportETA = {
  minTimeInSec: number
  maxTimeInSec: number
}

export type ReportData = {
  title: string
  subtitle: string
  last_updated: string
  sections: Section[]
}

export type WorkbookReportEntity = {
  id: string
  status: ReportStatus
  documentText: ReportData
  createdAt: string
  updatedAt: string
  eta: ReportETA
  documentType: string
  comment: string | null
  rating: number | null
  userId?: string
}

export const reportOptions = [
  "SEARCH_QUERY",
  "ACCOUNTPLAN",
  "DOCUMENTCOMPLIANCE",
  "PRODUCTRECOMMENDATION",
  "PRODUCTPOSITIONING",
  "PRODUCTCOMPARISON",
  "UPCROSSSELLOPPORTUNITY",
] as const

export type WorkbookReportTypeName = (typeof reportOptions)[number]

export type ReportDescriptor = {
  type: WorkbookReportTypeName
  displayName: string
  message: string
  icon: IconName
}

export const queryDocumentTypeToWorkbookTypeName = (
  documentType?: string | null
): WorkbookReportTypeName | null => {
  if (!documentType) return null
  switch (documentType) {
    case "Search Query":
      return "SEARCH_QUERY"
    case "Account Plan":
      return "ACCOUNTPLAN"
    case "Compliance Report":
      return "DOCUMENTCOMPLIANCE"
    case "Product Recommendation":
      return "PRODUCTRECOMMENDATION"
    case "Product Positioning":
      return "PRODUCTPOSITIONING"
    case "Product Comparison":
      return "PRODUCTCOMPARISON"
    case "Cross Sell Up Sell":
      return "UPCROSSSELLOPPORTUNITY"
    default:
      return null
  }
}

export const queryDocumentTypeToQueryTypeFilterName = (
  documentType?: WorkbookReportTypeName | null
): string | null => {
  if (!documentType) return null
  switch (documentType) {
    case "SEARCH_QUERY":
      return "Search Query"
    case "ACCOUNTPLAN":
      return "Account Plan"
    case "DOCUMENTCOMPLIANCE":
      return "Compliance Report"
    case "PRODUCTRECOMMENDATION":
      return "Product Recommendation"
    case "PRODUCTPOSITIONING":
      return "Product Positioning"
    case "PRODUCTCOMPARISON":
      return "Product Comparison"
    case "UPCROSSSELLOPPORTUNITY":
      return "Up Sell and Cross Sell Opportunities"
    default:
      return null
  }
}
